import * as React from "react";
import type { SVGProps } from "react";
const SvgKlarna = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="100%"
    height="100%"
    {...props}
  >
    <g clipPath="url(#klarna_svg__a)">
      <path
        fill="#343434"
        fillRule="evenodd"
        d="M3 13.926V10h.898v3.926zM6.141 10c0 .85-.33 1.64-.919 2.228l1.242 1.698h-1.11l-1.349-1.845.349-.262A2.26 2.26 0 0 0 5.262 10zm.584 3.925h.848v-3.924h-.848zm8.288-2.788c-.323 0-.63.101-.835.38v-.306h-.806v2.714h.816v-1.427c0-.412.276-.615.609-.615.356 0 .56.214.56.61v1.432h.81v-1.726c0-.632-.501-1.062-1.154-1.062m-4.877.247a1.42 1.42 0 0 0-1.35-.139 1.43 1.43 0 0 0-.773 1.87 1.43 1.43 0 0 0 2.124.636v.174h.81V11.21h-.81zM9.4 13.266c-.406 0-.734-.313-.734-.698 0-.386.328-.699.734-.699s.734.313.734.699-.329.698-.734.698m2.8-1.702v-.353h-.83v2.714h.832v-1.267c0-.428.462-.658.783-.658h.01v-.79c-.33 0-.632.142-.795.354m6.484-.18a1.42 1.42 0 0 0-1.35-.139 1.43 1.43 0 0 0-.773 1.87 1.43 1.43 0 0 0 2.124.636v.174h.81V11.21h-.81zm-.736 1.882c-.406 0-.735-.313-.735-.698 0-.386.329-.699.735-.699s.734.313.734.699-.329.698-.734.698m2.407-.304a.51.51 0 1 1-.002 1.018.51.51 0 0 1 .002-1.018"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="klarna_svg__a">
        <path fill="#fff" d="M3 10h18v4H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgKlarna;
